export default __webpack_public_path__ + "static/media/sad-nodi-reduce-3x.b661b0c8.webp";